import { useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { format, isAfter } from 'date-fns';
import OddsStore from '@mobx/stores/kolBetpick/kolOddsLastDate';

/** 賠率更新時間 */
const OddsLastUpdate = ({ curIndex }: { curIndex?: number }) => {
    const { t } = useTranslation('kol');
    const [dateString, setDateString] = useState<string>('');
    // console.log('curIndex----', curIndex);
    const MobxLastupdate = OddsStore.uniqueOddsLastDates;
    // console.log('MobxLastupdate1---------', MobxLastupdate);

    const styleObj = { boxShadow: '0px -8px 10px 0px rgba(0, 0, 0, 0.1)' };

    const getNearestDate = (dates: string[]): string => {
        const now = new Date();

        // 过滤并解析日期，只保留在当前时间之前的日期
        const validDates = dates
            .map((date) => new Date(date)) // 将字符串转换为 Date 对象
            .filter((date) => isAfter(now, date)); // 过滤出在当前时间之前的日期

        // 找到最近的日期
        const nearestDate =
            validDates.length > 0
                ? validDates.reduce((closest, date) => (isAfter(date, closest) ? date : closest))
                : null; // 如果没有有效日期，返回 null

        return nearestDate && nearestDate < now ? format(nearestDate, 'dd/MM/yyyy HH:mm') : '';
    };

    useEffect(() => {
        // console.log('MobxLastupdate---------', MobxLastupdate);
        const nearestDate = getNearestDate(MobxLastupdate);
        setDateString(nearestDate);
    }, [MobxLastupdate]);

    return (
        <div
            className='w-full py-[4px] px-[12px] bg-white border-b-[1px] border-[#E0E0E0] fixed left-0 bottom-0 z-50 text-[11px] font-medium text-black'
            style={curIndex === 0 ? styleObj : {}}
        >
            {`${t('lastUpdate')} ${dateString}`}
        </div>
    );
};

export default OddsLastUpdate;
